import Vue from "vue";
import {isLeadingSolutionsBrand} from "@/router"

const icon = (icon, enigmaIcon) => {
    return Vue.prototype.$iconData(icon, enigmaIcon).icon
}

const replaceIconPack = (menuItems, newIconPack) => {
    return menuItems.map(item => ({
        ...item,
        ...(item.submenu && { submenu: replaceIconPack(item.submenu, newIconPack) }),
        iconPack: newIconPack,
    }))
}

const menu = [
    {
        name: 'Home',
        url: '/home',
        slug: 'home',
        i18n: 'sideMenu.Home',
        icon: icon('icon-home', 'fi-rr-home'),
        permissionName: 'statistic_lead',
        iconPack: 'feather-icons'
    },
    {
        isDisplay: isLeadingSolutionsBrand,
        name: 'Analytics',
        url: '/analytics',
        slug: 'analytics',
        i18n: 'sideMenu.Analytics',
        icon: icon('icon-pie-chart', 'fi-rr-chart-pie-alt'),
        iconPack: 'feather-icons'
    },
    {
        name: 'Statistic',
        i18n: 'sideMenu.Statistic',
        icon: icon('icon-bar-chart', 'fi-rr-stats'),
        iconPack: 'feather-icons',
        submenu: [
            {
                isDisplay: !isLeadingSolutionsBrand,
                url: '/statistic/main',
                name: 'Main',
                i18n: 'sideMenu.Statistic_Main',
                slug: 'main_statistic',
                iconPack: 'feather-icons',
                icon: icon('icon-activity', 'fi-rr-chart-pie-alt'),
                permissionName: 'statistic_lead'  // todo change
            },
            {
                isDisplay: !isLeadingSolutionsBrand,
                url: '/statistic/leads',
                name: 'Leads',
                i18n: 'sideMenu.Statistic_Leads',
                slug: 'leads',
                iconPack: 'feather-icons',
                icon: icon('icon-users', 'fi-rr-users-alt'),
                permissionName: 'statistic_lead'
            },
            {
                url: '/statistic/recycle',
                name: 'Recycle',
                i18n: 'sideMenu.Recycle',
                slug: 'recycle',
                iconPack: 'feather-icons',
                icon: icon('icon-refresh-cw', 'fi-rr-refresh'),
                permissionName: 'recycle_leads'
            },
            {
                url: '/statistic/loads',
                name: 'Loads',
                i18n: 'sideMenu.Loads',
                slug: 'falcon',
                iconPack: 'feather-icons',
                icon: icon('icon-download', 'fi-rr-download'),
                permissionName: 'loads'
            },
            {
                url: '/statistic/uploads',
                name: 'Uploads',
                i18n: 'sideMenu.Uploads',
                slug: 'uploads',
                iconPack: 'feather-icons',
                icon: icon('icon-upload', 'fi-rr-upload'),
                permissionName: 'uploads,uploads_falcon'
            },
            // {
            //     url: '/statistic/advertiser',
            //     name: 'Advertiser',
            //     i18n: 'sideMenu.Advertiser',
            //     slug: 'advertiser',
            //     iconPack: 'feather-icons',
            //     icon: 'UsersIcon',
            //     permissionName: 'statistic_advertiser'
            // },
            // {
            //     url: '/statistic/adv',
            //     name: 'Advertisers',
            //     i18n: 'sideMenu.Advertiser',
            //     slug: 'advertisers',
            //     iconPack: 'feather-icons',
            //     icon: 'ShoppingBagIcon',
            //     permissionName: 'statistic_advertiser'
            // },
            // {
            //     url: '/statistic/deposits',
            //     name: 'Deposits',
            //     i18n: 'sideMenu.Deposits',
            //     slug: 'deposits',
            //     iconPack: 'feather-icons',
            //     icon: 'DollarSignIcon',
            //     permissionName: 'statistic_lead'
            // },
            // {
            //     url: '/statistic/offers',
            //     name: 'Offers',
            //     i18n: 'sideMenu.Offers',
            //     slug: 'offer',
            //     iconPack: 'feather-icons',
            //     icon: 'UsersIcon',
            //     permissionName: 'statistic_offer',
            //     isDisabled: true
            // },
            // {
            //     url: '/statistic/affiliate',
            //     name: 'Affiliate',
            //     i18n: 'sideMenu.Affiliate',
            //     slug: 'affiliate',
            //     iconPack: 'feather-icons',
            //     icon: 'UsersIcon',
            //     permissionName: 'statistic_affiliate',
            //     isDisabled: true
            // },
        ]
    },
    {
        url: null,
        name: 'Settings',
        i18n: 'sideMenu.Settings',
        icon: icon('icon-settings', 'fi-rr-settings'),
        iconPack: 'feather-icons',
        submenu: [
            {
                url: '/settings/advertisers',
                name: 'Advertisers',
                i18n: 'sideMenu.Advertiser',
                slug: 'advertisers',
                icon: icon('icon-shopping-bag', 'fi-rr-shopping-bag'),
                iconPack: 'feather-icons',
                permissionName: 'settings_advertiser'
            },
            {
                url: '/settings/teams',
                name: 'Teams',
                i18n: 'sideMenu.Settings_Teams',
                slug: 'teams',
                icon: icon('icon-users', 'fi-rr-users'),
                iconPack: 'feather-icons',
                permissionName: 'settings_team'
            },
            // {
            //     url: '/settings/deals',
            //     name: 'Deals',
            //     i18n: 'sideMenu.Deals',
            //     slug: 'deals',
            //     icon: 'ShuffleIcon',
            //     permissionName: 'deals'
            // },
            {
                url: '/settings/caps',
                name: 'Caps',
                i18n: 'sideMenu.Settings_Caps',
                slug: 'caps',
                icon: icon('icon-sliders', 'fi-rr-sliders-h-square'),
                iconPack: 'feather-icons',
                permissionName: 'settings_cap'
            },
            {
                url: '/settings/moderation',
                name: 'Moderation',
                i18n: 'sideMenu.Moderation',
                slug: 'moderation',
                icon: icon('icon-check-square', 'fi-rr-check-double'),
                iconPack: 'feather-icons',
                permissionName: 'settings_moderation'
            },
            {
                url: '/settings/offers',
                name: 'Offers',
                i18n: 'sideMenu.Offers',
                slug: 'settings-offers',
                icon: icon('icon-briefcase', 'fi-rr-briefcase'),
                iconPack: 'feather-icons',
                permissionName: 'settings_offer'
            },
            {
                url: '/settings/management',
                name: 'Management',
                i18n: 'sideMenu.Settings_Management',
                slug: 'settings_management',
                icon: icon('icon-users', 'fi-rr-business-time'),
                iconPack: 'feather-icons',
                permissionName: 'settings_management'
            },
            {
                url: '/settings/landings',
                name: 'Landings',
                i18n: 'sideMenu.Settings_Landings',
                slug: 'settings-landings',
                icon: icon('icon-hard-drive', 'fi-rr-hdd'),
                iconPack: 'feather-icons',
                permissionName: 'settings_landing'
            },
            {
                url: '/settings/statuses',
                name: 'Statuses',
                i18n: 'sideMenu.Statuses',
                slug: 'statuses',
                icon: icon('icon-file-text', 'fi-rr-document'),
                iconPack: 'feather-icons',
                permissionName: 'settings_status_mapper'
            },
            {
                url: '/settings/hold',
                name: 'Hold',
                i18n: 'sideMenu.Settings_Hold',
                slug: 'hold',
                icon: icon('icon-pause-circle', 'fi-rr-pause-circle'),
                iconPack: 'feather-icons',
                permissionName: 'settings_hold' //add permission!!!
            },
            {
                url: '/settings/geo',
                name: 'Geo',
                i18n: 'sideMenu.Settings_Geo',
                slug: 'geo',
                icon: icon('icon-map', 'fi-rr-map-marker'),
                iconPack: 'feather-icons',
                permissionName: 'settings_geo'
            },
            {
                url: '/settings/permissions',
                name: 'Permissions',
                i18n: 'sideMenu.Permissions',
                slug: 'permissions',
                icon: icon('icon-check-circle', 'fi-rr-check-circle'),
                iconPack: 'feather-icons',
                permissionName: 'permission'
            },
            {
                url: '/settings/system',
                name: 'System',
                i18n: 'sideMenu.Settings_System',
                slug: 'system',
                icon: icon('icon-settings', 'fi-rr-settings'),
                iconPack: 'feather-icons',
                permissionName: 'settings_system'
            }
        ]
    },
    {
        name: 'Check',
        i18n: 'sideMenu.Check',
        icon: icon('icon-user-check', 'fi-rr-user-check'),
        iconPack: 'feather-icons',
        submenu: [
            {
                url: '/check/testlead',
                name: 'Test lead',
                i18n: 'sideMenu.TestLead',
                slug: 'testlead',
                icon: icon('icon-user-check', 'fi-rr-user-check'),
                iconPack: 'feather-icons',
                permissionName: 'check_lead'
            }
        ]
    },
    {
        name: 'Finance',
        i18n: 'sideMenu.Finance',
        icon: icon('icon-dollar-sign', 'fi-rr-dollar'),
        iconPack: 'feather-icons',
        submenu: [
            {
                url: '/finance/statistic',
                name: 'Statistic',
                i18n: 'sideMenu.Statistic',
                slug: 'finance_statistic',
                icon: icon('icon-bar-chart-2', 'fi-rr-signal-alt-1'),
                iconPack: 'feather-icons',
                permissionName: 'finance_access'
            },
            {
                url: '/finance/analytics',
                name: 'Analytics',
                i18n: 'sideMenu.Analytics',
                slug: 'finance_analytics',
                icon: icon('icon-pie-chart', 'fi-rr-chart-pie-alt'),
                iconPack: 'feather-icons',
                permissionName: 'finance_analytic_access'
            },
            // {
            //     url: '/finance/cards',
            //     name: 'Cards',
            //     i18n: 'sideMenu.Cards',
            //     slug: 'finance_cards',
            //     icon: 'CreditCardIcon',
            //     permissionName: 'finance_cards',
            //     checkIsInternal: true,
            // }
        ]
    },
    {
        name: 'Logs',
        i18n: 'sideMenu.Logs',
        icon: icon('icon-cpu', 'fi-rr-microchip-ai'),
        iconPack: 'feather-icons',
        submenu: [
            {
                url: '/logs/leads',
                name: 'Leads',
                i18n: 'sideMenu.Leads',
                slug: 'leads',
                icon: icon('icon-users', 'fi-rr-users-alt'),
                iconPack: 'feather-icons',
                permissionName: 'logs' //todo add permission
            },
            {
                url: '/logs/changes',
                name: 'Changes',
                i18n: 'sideMenu.Changes',
                slug: 'changes',
                icon: icon('icon-edit-2', 'fi-rr-file-edit'),
                iconPack: 'feather-icons',
                permissionName: 'logs' //todo add permission
            },
        ]
    },
    {
        url: '/users',
        name: 'Users',
        i18n: 'sideMenu.Users',
        slug: 'users',
        icon: icon('icon-user', 'fi-rr-users'),
        iconPack: 'feather-icons',
        permissionName: 'user'
    },
    // {
    //     url: '/team',
    //     name: 'Team',
    //     i18n: 'sideMenu.Team',
    //     slug: 'team',
    //     icon: 'UsersIcon',
    //     permissionName: 'team',
    //     isDisabled: true
    // },
    {
        url: '/campaigns',
        name: 'Campaigns',
        i18n: 'sideMenu.Campaigns',
        slug: 'campaigns',
        icon: icon('icon-package', 'fi-rr-box-alt'),
        iconPack: 'feather-icons',
        permissionName: 'campaign'
    },
    {
        url: '/offers',
        name: 'Offers',
        i18n: 'sideMenu.Offers',
        slug: 'offers',
        icon: icon('icon-briefcase', 'fi-rr-briefcase'),
        iconPack: 'feather-icons',
        permissionName: 'offer',
        isDisabled: false
    },
    // {
    //     url: '/landings',
    //     name: 'Landings',
    //     i18n: 'sideMenu.Landings',
    //     slug: 'landings',
    //     icon: 'HardDriveIcon',
    //     permissionName: 'landing',
    //     isDisabled: true
    // },
    {
        url: '/domains',
        name: 'Domains',
        i18n: 'sideMenu.Domains',
        slug: 'domains',
        icon: icon('icon-link', 'fi-rr-link-alt'),
        iconPack: 'feather-icons',
        permissionName: 'domain',
        isDisabled: false
    },
    {
        url: '/postbacks',
        name: 'Postbacks',
        i18n: 'sideMenu.Postbacks',
        slug: 'postbacks',
        icon: icon('icon-corner-up-right', 'fi-rr-resize'),
        iconPack: 'feather-icons',
        permissionName: 'postback'
    },
    {
        url: '/notifications',
        name: 'Notifications',
        i18n: 'sideMenu.Notifications',
        slug: 'notifications',
        icon: icon('icon-bell', 'fi-rr-bell'),
        iconPack: 'feather-icons',
        permissionName: 'affiliate_bot'
    }
]

export default replaceIconPack(menu, process.env.VUE_APP_ICONS)
